export default __webpack_public_path__ + "static/media/day_book_.1ce72ad3.xlsx";